import productone from '../../assets/product-1.jpg'
import producttwo from '../../assets/Product-2.jpg'
import producthree from '../../assets/product-3.jpg'
import '../OurProduct/OurProduct.scss'
import { HiOutlineSupport } from "react-icons/hi";
import { LuSquareMenu } from "react-icons/lu";


const OurProduct = () => {
  return (
    <div className='our-product-section'>
      <div style={{padding:'50px 50px'}}>
        <h2 className='our-product-heading' style={{color:'white'}}><span style={{color:'gray'}}>OUR</span> PRODUCT</h2>
      </div>
      <div>
        <div className='product-section' style={{display:'grid', gridTemplateColumns:'59.5% 39.5%',gap:'0.5%', height:'90vh' }}>
            <div className='product-left-section' style={{display:'grid', gridTemplateRows:'59.5% 49.5%', gap:'1%'}} >
              <div className='over-flow-producter-1'>
              <div className='product-one-img' style={{backgroundImage:`url(${productone})`, color:'white',position:'relative', height:'100%'}}>
                <div className='product-text' style={{position:'absolute', bottom:'50px', left:'50px'}}>
                <h1>BADMINTON KIT</h1>
                <p>Lightweight graphite racket for precision shots</p>
                </div>
              </div>
              </div>
                <div className='left-flex-box' style={{display:'grid', gridTemplateColumns:'49.5% 49.5%', gap:'1%'}}>
                <div className='product-sectioncolor-box' style={{padding:'50px', display:'flex', flexDirection:'column', gap:'10px', color:'white'}}>
                    <HiOutlineSupport size={50} />
                    <h3>Expert <br /> Support</h3>
                    <p>Our knowledgeable staff is here to help you pick the right gear tailored to your needs.</p>
                </div>
                <div className="over-flow-producter-2">
                <div className='product-two-img' style={{backgroundImage:`url(${producttwo})`, position:'relative', height:'100%', color:'white'}}>
                  <div className='product-text' style={{position:'absolute', bottom:'50px', left:'50px'}}>
                  <h1>SPORTS SHOES</h1>
                  <p>Non-slip sports shoes with extra grip</p>
                  </div>
                </div>
                </div>  
                </div>
            </div>
            <div className='product-right-section' style={{display:'grid',gridTemplateRows:"44.5% 64.5%", gap:'1%'}}>
                <div className='product-sectioncolor-box' style={{ padding: '35px',display:'flex', flexDirection:'column' ,gap:'10px', color:'white'}}>
                <LuSquareMenu size={40} />
                <h3>Trusted Brands</h3>
                <p>We carefully curate our inventory to include only top-quality brands renowned for their innovation, durability, and performance. These are the same trusted names that professional athletes and sports enthusiasts around the world rely on to deliver excellence on and off the field.</p>
                </div>
                <div className="over-flow-producter-3">
                <div className='product-three-img' style={{backgroundImage:`url(${producthree})`, height:'100%', position:'relative'}}>
                  <div className='product-text'  style={{position:'absolute', bottom:'40px', left:'50px', color:'white'}}>
                    <h1>TROPHY & MEDALS</h1>
                    <p>School & college competitions Corporate and inter-office tournaments</p>
                  </div>
                </div>
                </div>
            </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  )
}

export default OurProduct
